import { Link, useLocation, useNavigate } from "react-router-dom"
import { useRef, useState } from "react";
import { handleError, useAuth } from "../../modules/authentication/AuthProvider";
import { Input, Button, Alert } from "react-daisyui";
import routes from "../../modules/routes/Routes";
import { AuthError } from "@supabase/supabase-js";
import AuthenticationScreen from "./AuthenticationScreen";
import { useTranslation } from 'react-i18next';

const Forgot: React.FC = () => {
    const { sendPasswordResetMail } = useAuth();
    const { t } = useTranslation();

    const emailRef = useRef<HTMLInputElement>(null);

    const [emailError, setEmailError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [resetSent, setResetSent] = useState<boolean>(false);

    const navigate = useNavigate();

    async function handleAuthError(error: AuthError) {
        const handledError = handleError(error);

        console.log({ error, authError: handledError })

        if (handledError) {
            setEmailError(handledError.message);
        }
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        setEmailError(null);

        if (emailRef.current) {
            setLoading(true);

            const { error } = await sendPasswordResetMail(emailRef.current.value);

            if (error !== null) {
                handleAuthError(error);
            } else {
                setResetSent(true);
            }
        }
        setLoading(false);
    }

    return (
        <AuthenticationScreen title="Forgot Password">
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <div className="flex flex-col gap-3">
                    {resetSent ? (
                        <Alert color="success">
                            Password reset email sent. Please check your inbox.
                        </Alert>
                    ) : (
                        <>
                            <Input 
                                ref={emailRef} 
                                type="email" 
                                placeholder="Enter your email"
                                color={emailError !== null ? "error" : undefined} 
                                required 
                            />
                            <Button type="submit" color="primary" disabled={loading}>
                                {loading ? "Sending reset email..." : "Send Reset Email"}
                            </Button>

                            {emailError !== null && (
                                <Alert color="error">
                                    {emailError}
                                </Alert>
                            )}
                        </>
                    )}

                    <p className="mt-3 text-sm">
                        Remember your password? <Link to={routes.authentication.login.build()} className="text-primary">Back to Login</Link>
                    </p>
                </div>
            </form>
        </AuthenticationScreen>
    );
}

export default Forgot;